module.exports = __webpack_public_path__ + "static/media/profile-picture.41e90b3c.png";